// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TBv5","index":"styles_index__LVWjy"};